export const getAdminUrl = (path = "/admin") => {
  if (typeof window === "undefined") return path;
  return `${window.location.origin}${path}`;
};

export const getMainLoginUrl = () => {
  if (typeof window === "undefined") return "/login";
  return `${window.location.origin}/login`;
};
